import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../component/Breadcrumb';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
// import JsonViewer from './JsonViewer';

//import ReactJson from 'react-json-view';
//import { JsonEditor } from 'json-edit-react'

import swal from 'sweetalert';

const JsonMappings = () => {

    const [jsonMappingData,setJsonMappingData] = useState([]);

    useEffect(()=> {
        const keys = Object.keys(localStorage);
        let data = {};
        keys.filter((k) =>  k === 'Connections' || k === 'Parameters' || k === 'Events' || k === 'ECURequestPGN' || k === 'ECUReceiveMessages' || k === 'ECUConstantTxMessages' || k === 'HomePage' || k === 'ECUIDDefinitions' || k === 'ECUTransmitMessages' || k === 'Modbus').map((key) => data[key] = localStorage?.getItem(key) ? JSON.parse(localStorage?.getItem(key)) : '');
        setJsonMappingData(data);
    },[]);

    // const editMappingJson = (editData) => {
    //     //console.log('editData',editData)
    //     try {
    //     const {updated_src,existing_value,new_value} = editData;
    //     if(existing_value === undefined || new_value === undefined){
    //         return;
    //     }

    //     if(typeof existing_value !== typeof new_value){
    //         //console.log('error')
    //         swal("Error", "Please use valid datatype.", "error");
    //         //setJsonMappingData(existing_src);
    //         return false;
    //         // setJsonMappingData(updated_src);
    //         // for(let key in updated_src){
    //         //     localStorage.setItem(key,JSON.stringify(updated_src[key]));
    //         // }
    //     }

    //     if(typeof existing_value === typeof new_value){
    //         //console.log('hello')
    //         setJsonMappingData(updated_src);
    //     } 
    //     //return true;
    // } catch (error) {
    //     swal("Error", error.message, "error");
    //     //return false;
    // }

    // }

    // const addMappingJson = (e) => {
    //    // console.log('add',e)
    // }

    // const deleteMappingJson = (e) => {
    //    // console.log('delete',e)
    // }

    // const defaultValueFunction = (e) => {
    //     if(e.level === 1) {
    //         return {};
    //     }  else {
    //         return "";
    //     }
    // }
    
    const handleValidationJson = () => {
        let errorList = [];
        const mandatoryKeys = ["Parameters","Connections","Events","Modbus","ECUIDDefinitions","ECUReceiveMessages","ECUTransmitMessages","HomePage"];
        const myJsonArrKeys = Object.keys(jsonMappingData);
        if(!mandatoryKeys?.every(item => myJsonArrKeys.includes(item))){
            errorList.push("Parameters, Connections, Events, Modbus, ECUIDDefinitions, ECUReceiveMessages, ECUTransmitMessages, HomePage are mandatory blocks.");
        }
        
        if(jsonMappingData?.Parameters && !jsonMappingData?.Parameters?.every(obj => obj.hasOwnProperty('Addr'))){
            errorList.push("Addr key is missing in Parameters.");
        }

        if(jsonMappingData?.Connections && !jsonMappingData?.Connections?.every(obj => obj.hasOwnProperty('LParam') && obj.hasOwnProperty('RParam'))){
            errorList.push("LParam or RParam key is missing in Connections.");
        }

        if(jsonMappingData?.Modbus && !jsonMappingData?.Modbus?.every(obj => obj.hasOwnProperty('RegAddr') && obj.hasOwnProperty('Addr'))){
            errorList.push("RegAddr or Addr key is missing in Modbus.");
        }

        if(jsonMappingData?.HomePage && !jsonMappingData?.HomePage?.every(obj => obj.hasOwnProperty('PId') && obj.PId !== '')){
            errorList.push("PId key is missing or its value is missing in HomePage.");
        }

        if(jsonMappingData?.Events && !jsonMappingData?.Events?.every(obj => obj.hasOwnProperty('EId'))){
            errorList.push("EId key is missing missing in Events.");
        }

        if(jsonMappingData?.ECUConstantTxMessages && !jsonMappingData?.ECUConstantTxMessages?.every(obj => obj.hasOwnProperty('ECMID'))){
            errorList.push("ECMID key is missing missing in ECUConstantTxMessages.");
        }

        if(jsonMappingData?.ECUIDDefinitions && !jsonMappingData?.ECUIDDefinitions?.every(obj => obj.hasOwnProperty('ECMID'))){
            errorList.push("ECMID key is missing missing in ECUIDDefinitions.");
        }

        if(jsonMappingData?.ECURequestPGN && !jsonMappingData?.ECURequestPGN?.every(obj => obj.hasOwnProperty('ECMID'))){
            errorList.push("ECMID key is missing missing in ECURequestPGN.");
        }

        if(jsonMappingData?.ECUReceiveMessages && !jsonMappingData?.ECUReceiveMessages?.every(obj => obj.hasOwnProperty('Addr'))){
            errorList.push("Addr key is missing missing ECUReceiveMessages.");
        }

        if(jsonMappingData?.ECUTransmitMessages && !jsonMappingData?.ECUTransmitMessages?.every(obj => obj.hasOwnProperty('Addr'))){
            errorList.push("Addr key is missing missing in ECUTransmitMessages.");
        }


        if(errorList.length > 0){
            let errors = errorList.join('\n');
            swal({
                title: "Oops",
                text: errors,
                icon: "error",
            })
        } else {
            swal({
                title: "Success",
                text: 'No issues found with the Configuration file',
                icon: "success",
            })
        }
    }

    return (
        <>
            <Breadcrumb title="Configuration Validator">
                <Typography variant="subtitle2" color="#8C8C8C" className="link-breadcrumb">
                View
                </Typography>
                <Typography variant="subtitle2" className="link-breadcrumb">
                Validator
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">
                    {/*<JsonEditor 
                        theme="githubDark"
                        enableClipboard={false}
                        data={jsonMappingData} 
                        rootName={"Mapping"}
                        onEdit={editMappingJson}
                        onAdd={addMappingJson}
                        onDelete={deleteMappingJson}
                        maxWidth={"100%"}
                        restrictTypeSelection={false}
                        defaultValue={defaultValueFunction}
                        restrictEdit={true}
                        restrictDelete={true}
                        restrictAdd={true}
                    />*/}
                    {/* <JsonViewer 
                        data={jsonMappingData}
                    /> */}
                    <Button 
                        onClickCapture={handleValidationJson}
                        color="primary"
                        variant="contained"
                        size='small'
                    >
                        Validate JSON
                    </Button>
                     <TextField 
                        value={JSON.stringify(jsonMappingData,null,2)}
                        multiline
                        minRows={4}
                        style={{ width: "100%",paddingTop:'10px' }}
                     />   
                     {/* <p>{JSON.stringify(jsonMappingData,null,4)}</p> */}
                </Grid>
            </Box>
        </>
    )
}

export default JsonMappings